import React from 'react'
import { Checkbox, CheckboxProps, makeStyles } from '@material-ui/core'
import CircleCheckedFilled from '@material-ui/icons/CheckCircle'
import CircleUnchecked from '@material-ui/icons/RadioButtonUnchecked'

type RoundedCheckboxProps = Omit<CheckboxProps, 'color'> & {
  color?: string
}

export const RoundedCheckbox = React.forwardRef<HTMLButtonElement, RoundedCheckboxProps>(
  ({ color = '#1976d2', ...props }, ref) => {
    const classes = useStyles()
    return (
      <Checkbox
        ref={ref}
        className={classes.checkbox}
        color="default"
        icon={<CircleUnchecked style={{ color }}/>}
        checkedIcon={<CircleCheckedFilled style={{ color }}/>}
        {...props}
      />
    )
  }
)

RoundedCheckbox.displayName = 'RoundedCheckbox'

const useStyles = makeStyles({
  checkbox: {
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
})
